import { useContext } from 'react';
import { DeploymentPreviewContext } from './DeploymentPreviewContext';

export const useDeploymentPreviewContext = () =>
  useContext(DeploymentPreviewContext);
